import { EventNames } from '@farmasiet/frontendcore-reactcomponents';
import React, { createContext, FC, useEffect, useState } from 'react';

import { UserDetailsViewModel } from '../../Purchase/Cart/PersonalizedCart/UserDetailsViewModel.csharp';

export interface UserContextModel {
    isLogged: boolean;
    isReady: boolean;
    user?: UserDetailsViewModel;
}

export const UserContext = createContext<UserContextModel>({} as UserContextModel);

export const UserContextProvider: FC = (props) => {
    const [user, setUser] = useState<UserDetailsViewModel>();

    useEffect(() => {
        window.addEventListener(EventNames.UserDetailsLoaded, onUserDetailsLoaded);

        return () => {
            window.removeEventListener(EventNames.UserDetailsLoaded, onUserDetailsLoaded);
        };
    }, []);

    const onUserDetailsLoaded = ($event: CustomEventInit) => {
        if ($event && $event.detail) {
            setUser($event.detail.user as UserDetailsViewModel);
        }
    };

    return <UserContext.Provider value={{ isLogged: user?.isLoggedIn || false, user, isReady: !!user }}>{props.children}</UserContext.Provider>;
};
